<template>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
    <div class="x_panel">
      <div class="x_title">
        <h2>{{ isInternal ? 'Delivered' : 'Shipped' }} Date</h2>
        <ul class="nav navbar-right panel_toolbox">
          <li v-if="item.billOfLading">
            <div
              class="btn-group"
              role="group"
              aria-label="Button">
              <a
                :href="item.billOfLading"
                :download="item.billOfLading"
                target="_blank"
                class="btn btn-default po-tile-edit-button">
                <i
                  class="fa fa-paperclip download-file-icon"
                  aria-hidden="true"></i> Download B/L
              </a>
              <button
                class="btn btn-default po-tile-edit-button"
                @click="editBlFileDialog = true"
                v-if="item.shippedAt && (checkUserGroup(getGroups.FACTORY) ||
              checkUserGroup(getGroups.MANAGE))">
                <i class="fa fa-edit"></i> Edit
              </button>
            </div>
          </li>
          <li v-else>
            <button
              class="btn btn-default po-tile-edit-button"
              @click="editBlFileDialog = true"
              v-if="item.shippedAt && (checkUserGroup(getGroups.FACTORY) ||
            checkUserGroup(getGroups.MANAGE))">
              <i class="fa fa-plus"></i> Add B/L File
            </button>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div
        class="x_content"
        v-if="item.shippedAt">
        <div class="tile-stats">
          <div class="icon">
            <i class="fa fa-calendar"></i>
          </div>
          <div class="count">{{ item.shippedAt | moment('Do MMMM YYYY') }} </div>
          <h4><em>Added {{ item.statusShippedAt | moment("from", "now") }}</em></h4>
        </div>
      </div>
      <div
        class="x_content"
        v-else>
        <div class="tile-stats">
          <div class="row">
            <h3 class="text-center empty-title">
              PO has not been {{ isInternal ? 'delivered' : 'shipped' }} yet.
            </h3>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Add or edit B/L file"
      :visible.sync="editBlFileDialog">
      <el-form >
        <fieldset>
          <el-form-item label="Attach the B/L file">
            <el-upload
              class="upload-bl-file"
              ref="uploadPBlFile"
              :headers="getHeaders"
              :on-error="onUploadError"
              :on-success="onUploadSucces"
              :before-upload="setIsUpload"
              :action="actionUrl">
              <el-button
                slot="trigger"
                :plain="true"
                type="success"
                size="large">
                <i
                  class="fa fa-file-o"
                  aria-hidden="true"></i>  Select the B/L file
              </el-button>
            </el-upload>
          </el-form-item>
        </fieldset>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          :plain="true"
          :disabled="isUpload"
          @click="editBlFileDialog = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import apiUrl from '@/services/api_url';
import getFileUploadHeaders from '@/services/http-file-headers';
import * as groups from '@/js/user-groups';
import * as types from '@/store/mutation-types';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    updates: {
      type: Array,
      default() {
        return [];
      },
    },
    isInternal: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      editBlFileDialog: false,
      actionUrl: '',
      isUpload: false,
      billOfLadingUpdates: [],
    };
  },
  computed: {
    getGroups() {
      return groups;
    },
    ...mapGetters({
      getPoShippedDate: 'getPoShippedDate',
      getUser: 'getUser',
    }),
    getHeaders() {
      return getFileUploadHeaders();
    },
  },
  created() {
    this.actionUrl = `${apiUrl}pos/${this.item.id}/sendBillOfLading/`;
    for (let i = 0; i < this.updates.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(this.updates[i], 'shippedAt') || Object.prototype.hasOwnProperty.call(this.updates[i], 'billOfLading')) {
        this.billOfLadingUpdates.push(this.updates[i]);
      }
    }
  },
  methods: {
    checkUserGroup(group) {
      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()) {
            return true;
          }
        }
      }
      return true;
    },
    setIsUpload() {
      this.isUpload = true;
    },
    onUploadSucces(response) {
      this.$message.success('Success! B/L was uploaded.');
      this.isUpload = false;
      this.editBlFileDialog = false;
      this.$store.commit(types.SET_PO_ITEM, response);
      this.$refs.uploadPBlFile.clearFiles();
    },
    onUploadError() {
      this.$message.error('Oops! Something went wrong.');
      this.isUpload = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-title {
  margin: 50px 0;
}
.download-file-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoShippedDate.vue